import * as React from 'react';
import './App.css';
import Homepage from "./homepage/homepage";
import {Redirect, Route, RouteComponentProps, Switch} from 'react-router-dom'
import Application from "./metamodel/Application";
import DetailPage from "./pages/client/detailPage";
import AboutPage from "./pages/client/aboutPage";
import Switchpage from "./switchpage/switchpage";

/* tslint:disable:interface-name */
export interface AppProps {
    metaModel: Application,
    headerUrl: string,
    logoUrl: string,
    aboutInfo: string,
    hideGegevensBlock: boolean,
    switcherBackgroundUrl: string
}

export default class App extends React.Component<AppProps, {}> {
    public render() {
        const detailRender = this.renderDetailPage.bind(this);
        const homeRender = this.renderHomePage.bind(this);
        const aboutRender = this.renderAboutPage.bind(this);
        const switchRender = this.renderSwitchPage.bind(this);
        return <Switch>
                    <Redirect from="/zoeken/pagina/:page" to={`/${this.props.metaModel.entities[0].id}/zoeken/pagina/:page`}/>
                    <Route path={`/:entity/zoeken/pagina/:page`} render={homeRender}/>
                    <Route path={`/:entity/:id`} render={detailRender}/>
                    <Route exact={true} path="/over-de-app" render={aboutRender}/>
                    <Route exact={true} path="/" render={switchRender}/>
                </Switch>;
    }

    private renderHomePage({ match, history } : RouteComponentProps<any>) {
        let page = 1;
        if (match.params.page) {
            page = parseInt(match.params.page, 10);
            if (isNaN(page)) {
                page = 1;
            }
            if(page === 0) {
                page = 1;
            }
        }
        const entity = this.props.metaModel.entities.find(e => e.id === match.params.entity);
        if (!entity) {
           history.push('/');
           return <h1>Deze pagina kon niet worden gevonden.</h1>
        }
        return <Homepage page={page} activeEntity={entity} key={`homepage-${entity.id}`} history={history} logoUrl={this.props.logoUrl} headerUrl={this.props.headerUrl} metaModel={this.props.metaModel}/>;
    }

    private renderDetailPage({ match, location, history } : RouteComponentProps<any>) {
        const returnUrl = location.state && location.state.returnUrl || "/";
        const entity = this.props.metaModel.entities.find(e => e.id === match.params.entity);
        if (!entity) {
            history.push('/');
            return <h1>Deze pagina kon niet worden gevonden.</h1>
        }
        return <DetailPage key="detailpage" returnUrl={returnUrl} hideGegevensBlock={this.props.hideGegevensBlock} id={match.params.id} entity={entity}/>
    }

    private renderAboutPage() {
        return <AboutPage metaModel={this.props.metaModel} logoUrl={this.props.logoUrl} headerUrl={this.props.headerUrl} content={this.props.aboutInfo} key="about"/>;
    }

    private renderSwitchPage({ history } : RouteComponentProps<any>) {
        return <Switchpage metaModel={this.props.metaModel} history={history} logoUrl={this.props.logoUrl} backgroundUrl={this.props.switcherBackgroundUrl} key="switch"/>;
    }
}



// WEBPACK FOOTER //
// ./src/App.tsx